




















import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class ReferralStatusWiseCount extends Vue {
  @Prop() referred;
  @Prop() offered;
  @Prop() hired;
  @Prop() applied;
  @Prop() registered;
  @Prop() referralLevel;
  get referralStatus() {
    return [
      {
        text: this.$t('myreferrals.referred'),
        count: this.referred,
      },
      {
        text: this.$t('myreferrals.signedup'),
        count: this.registered,
      },
      {
        text: this.$t('myreferrals.applied'),
        count: this.applied,
      },
      {
        text: this.$t('myreferrals.hired'),
        count: this.hired,
      },
    ];
  }
}
